import { selectLegacyFeatureFlagValue } from '@libs/focus-frontend-store/src/User/selectors';

import { setLegacyFeatureFlag } from './actions';

/* eslint typescript-sort-keys/string-enum: "error" */
export enum LegacyFeatureFlag {
  BccMyselfWhenSendingOffer = 'bcc_myself_when_sending_offer',
  InvoiceableDefaultOff = 'invoiceable_default_off',
  InvoicesEnableStrictMode = 'invoices_enable_strict_mode',
  InvoicesExportToUbl = 'invoices_export_to_ubl',
  PdfAttachmentWhenSendingOffer = 'pdf_attachment_when_sending_offer',
  ProjectsExtraUseExternalOrderNumbers = 'projects_extra_use_external_order_numbers',
}

export const get = (key: LegacyFeatureFlag) => selectLegacyFeatureFlagValue(key)(window.top!.store.getState());

export const set = (key: LegacyFeatureFlag, value: 'on' | 'off', extraInfo = null) => {
  window.top!.store.dispatch(setLegacyFeatureFlag(key, value, extraInfo));
};
